import ShareableLinkTermsAndConditions from './ShareableLinkTermsAndConditions.component';

export default ShareableLinkTermsAndConditions;